let clientY = 0;

export function addElementTouchFix() {
    if(iOS()) {
        document.body.addEventListener('touchstart', e => {
            const targetEl = e.target;
            if(
                targetEl.parentNode.classList.contains('el-date-table__row') // days in calendar
                || targetEl.classList.contains('el-date-picker__header-label') // year/month buttons in calendar header
                || targetEl.classList.contains('el-picker-panel__icon-btn') // next/prev buttons in calendar header
                || targetEl.classList.contains('time-select-item') // time in time select field
            ) {
                clientY = e.touches[0].clientY;
                targetEl.addEventListener('touchend', touchEndHandler);
            }
        });
    }
}

function touchEndHandler(e) {{
    let endClientY = e.changedTouches[0].clientY;
    e.target.removeEventListener('touchend', touchEndHandler);
    if(Math.abs(clientY - endClientY) < 10) { // check if the intended action is not swiping (but leave some margin for accidental finger move)
        e.target.dispatchEvent(new Event('click', {bubbles: true}));
    }
}}

function iOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}